<template>
    <v-dialog v-model="value" persistent max-width="500">
        <v-card>
            <v-card-title class="primary white--text">{{
                titulo
            }}</v-card-title>
            <v-card-text class="mt-6">
                <slot></slot>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" text @click="ok">Ok</v-btn>
                <v-btn color="primary" text @click="cancelar">Cancelar</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: "yes-cancel-dialog",
    props: {
        value: {
            type: Boolean,
            required: true,
        },
        titulo: {
            type: String,
        },
    },
    methods: {
        ok() {
            this.$emit("ok");
            this.$emit("input", false);
        },
        cancelar() {
            this.$emit("cancelar");
            this.$emit("input", false);
        },
    },
};
</script>
